// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

const SECURITY_AREA_ID = 4;
const BUSINESS_ANALYTICS_AREA_ID = 5;
const SECURITY_CORRELATIONS_EXTENSION_ID = 1;
const SECURITY_CORRELATIONS_NAV_LABEL = 'Security Correlations';
const USAGE_NAV_LABEL = 'Usage';
const SOURCES_NAV_LABEL = 'Sources';


class KeyGoalsListNav extends Component {

  isPreviousLinkSecurityCorrelations() {
    const { area, activeAreaIds } = this.props;
    const extension = this.getExtension();

    return (
      area.id === BUSINESS_ANALYTICS_AREA_ID &&
      activeAreaIds.includes(SECURITY_AREA_ID) &&
      extension &&
      extension.extension.id === SECURITY_CORRELATIONS_EXTENSION_ID &&
      extension.active
    );
  }

  isPreviousLinkPreviousArea() {
    const { area, activeAreaIds } = this.props;
    const extension = this.getExtension();
    const previousArea = this.getPreviousArea();

    return (
      !activeAreaIds.includes(SECURITY_AREA_ID) ||
      !extension ||
      !extension.active ||
      area.id !== BUSINESS_ANALYTICS_AREA_ID
    ) && previousArea;
  }

  getPreviousAreaId() {
    const { area, activeAreaIds } = this.props;

    return (
      area &&
      activeAreaIds &&
      activeAreaIds[activeAreaIds.indexOf(area.id) - 1]
    );
  }

  getBaseUrl() {
    const { baseNavRoute } = this.props;
    return baseNavRoute;
  }

  getSecurityCorrelationsUrl() {
    const extension = this.getExtension();
    return `${this.getBaseUrl()}/correlations/${extension.id}`;
  }

  getPreviousAreaUrl() {
    const previousArea = this.getPreviousArea();
    return `${this.getBaseUrl()}/goals/${previousArea.id}`;
  }

  getPreviousArea() {
    const { areas } = this.props;
    const previousAreaId = this.getPreviousAreaId();
    return areas.find(a => a.id === previousAreaId);
  }

  getNextAreaId() {
    const { area, activeAreaIds } = this.props;

    return (
      area &&
      activeAreaIds &&
      activeAreaIds[activeAreaIds.indexOf(area.id) + 1]
    );
  }

  getExtension() {
    const { extensions } = this.props;

    return (
      extensions &&
      extensions.length ?
      extensions[0] :
      null
    );
  }

  getNextArea() {
    const nextAreaId = this.getNextAreaId();
    const { areas } = this.props;

    return areas.find(a => a.id === nextAreaId);
  }

  renderPreviousLinkTo(title, to) {
    return (
      <div className='prev-link'>
        <Link to={to} className='previous'>
          &#60; Previous: {title}
        </Link>
      </div>
    );
  }

  renderPreviousLink() {
    const previousArea = this.getPreviousArea();

    if (this.isPreviousLinkSecurityCorrelations()) {
      return this.renderPreviousLinkTo(
        SECURITY_CORRELATIONS_NAV_LABEL,
        this.getSecurityCorrelationsUrl()
      );
    } else if (this.isPreviousLinkPreviousArea()) {
      return this.renderPreviousLinkTo(
        previousArea.title,
        this.getPreviousAreaUrl()
      );
    }
  }

  isNextLinkSecurityCorrelations() {
    const { area } = this.props;
    const extension = this.getExtension();

    return (
      area.id === SECURITY_AREA_ID &&
      extension &&
      extension.extension.id === SECURITY_CORRELATIONS_EXTENSION_ID &&
      extension.active
    );
  }

  isNextLinkNextArea() {
    const { area } = this.props;
    const extension = this.getExtension();
    const nextArea = this.getNextArea();

    return (
      !extension ||
      !extension.active ||
      area.id !== SECURITY_AREA_ID
    ) && nextArea;
  }

  getNextAreaUrl() {
    const nextArea = this.getNextArea();
    return `${this.getBaseUrl()}/goals/${nextArea.id}`;
  }

  getUsageUrl() {
    return `${this.getBaseUrl()}/usage`;
  }

  getSourcesUrl() {
    return `${this.getBaseUrl()}/sources`;
  }

  isNextLinkUsage() {
    const { dsa } = this.props;
    const nextArea = this.getNextArea();
    return dsa && !nextArea;
  }

  isNextLinkSources() {
    const { dsa, canEditUsage } = this.props;
    return dsa && !canEditUsage;
  }

  renderNextLinkTo(title, to) {
    return (
      <div className='next-link'>
        <Link to={to} className='next'>
          Next: {title} &#62;
        </Link>
      </div>
    );
  }

  renderNextLink() {
    const nextArea = this.getNextArea();

    if (this.isNextLinkSecurityCorrelations()) {
      return this.renderNextLinkTo(
        SECURITY_CORRELATIONS_NAV_LABEL,
        this.getSecurityCorrelationsUrl()
      );
    } else if (this.isNextLinkNextArea()) {
      return this.renderNextLinkTo(
        nextArea.title,
        this.getNextAreaUrl()
      );
    } else if (this.isNextLinkSources()) {
      return this.renderNextLinkTo(
        SOURCES_NAV_LABEL,
        this.getSourcesUrl()
      );
    } else if (this.isNextLinkUsage()) {
      return this.renderNextLinkTo(
        USAGE_NAV_LABEL,
        this.getUsageUrl()
      );
    }
  }

  isSecurityArea() {
    const { area } = this.props;
    return area.id === SECURITY_AREA_ID;
  }

  render() {
    return (
      <div>
        <div className='next-prev-links'>
          {this.renderPreviousLink()}
          {this.renderNextLink()}
        </div>
      </div>
    );
  }
}

KeyGoalsListNav.propTypes = {
  area: PropTypes.object,
  activeAreaIds: PropTypes.array,
  dsa: PropTypes.object,
  areas: PropTypes.array,
  extensions: PropTypes.array,
  canEditUsage: PropTypes.bool,
  baseNavRoute: PropTypes.string.isRequired
};

export default KeyGoalsListNav;



// WEBPACK FOOTER //
// ./src/components/goals/KeyGoalsListNav.js